import { FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';

type ValueReader = () => unknown;
type ChangeHandler = (hasChanged: boolean) => void;

/**
 * Reusable form change tracker:
 * - capture initial snapshot
 * - watch value changes
 * - compute unsaved state by snapshot diff
 */
export class FormChangeTracker {
  private initialSnapshot = '';
  private subscription?: Subscription;
  private changed = false;

  constructor(
    private readonly form: FormGroup,
    private readonly readValue: ValueReader = () => this.form.value
  ) {}

  start(onChange: ChangeHandler): void {
    this.stop();
    this.reset();
    this.subscription = this.form.valueChanges.subscribe(() => {
      this.changed = this.serialize(this.readValue()) !== this.initialSnapshot;
      onChange(this.changed);
    });
  }

  reset(): void {
    this.initialSnapshot = this.serialize(this.readValue());
    this.changed = false;
  }

  stop(): void {
    this.subscription?.unsubscribe();
    this.subscription = undefined;
  }

  hasChanged(): boolean {
    this.changed = this.serialize(this.readValue()) !== this.initialSnapshot;
    return this.changed;
  }

  private serialize(value: unknown): string {
    return JSON.stringify(value ?? null);
  }
}
